/**
 * Generated by "@vuepress/internal-site-data"
 */
export const siteData = {
  "title": "eTools",
  "description": "易语言助手",
  "base": "/docs/",
  "pages": [
    {
      "title": "易语言助手",
      "frontmatter": {},
      "regularPath": "/",
      "relativePath": "README.md",
      "key": "v-24521a4c",
      "path": "/"
    },
    {
      "title": "介绍",
      "frontmatter": {},
      "regularPath": "/f41/t1.html",
      "relativePath": "f41/t1.md",
      "key": "v-ab8ab24a",
      "path": "/f41/t1.html",
      "headers": [
        {
          "level": 2,
          "title": "易语言助手是什么？",
          "slug": "易语言助手是什么？"
        },
        {
          "level": 2,
          "title": "易语言助手能做什么？",
          "slug": "易语言助手能做什么？"
        },
        {
          "level": 2,
          "title": "特性",
          "slug": "特性"
        }
      ]
    },
    {
      "title": "FAQ",
      "frontmatter": {},
      "regularPath": "/f41/t3.html",
      "relativePath": "f41/t3.md",
      "key": "v-70c813d7",
      "path": "/f41/t3.html",
      "headers": [
        {
          "level": 2,
          "title": "插件冲突问题",
          "slug": "插件冲突问题"
        },
        {
          "level": 2,
          "title": "调试过程中崩溃问题",
          "slug": "调试过程中崩溃问题"
        },
        {
          "level": 2,
          "title": "安装或更新失败问题",
          "slug": "安装或更新失败问题"
        },
        {
          "level": 2,
          "title": "eFrame接口初始化失败的问题",
          "slug": "eframe接口初始化失败的问题"
        },
        {
          "level": 2,
          "title": "win10系统使用异常问题",
          "slug": "win10系统使用异常问题"
        },
        {
          "level": 2,
          "title": "支持库冲突问题",
          "slug": "支持库冲突问题"
        }
      ]
    },
    {
      "title": "快速上手",
      "frontmatter": {},
      "regularPath": "/f42/t4.html",
      "relativePath": "f42/t4.md",
      "key": "v-9404c9d2",
      "path": "/f42/t4.html",
      "headers": [
        {
          "level": 2,
          "title": "快速开发一个带提示的插件",
          "slug": "快速开发一个带提示的插件"
        }
      ]
    },
    {
      "title": "开发工具",
      "frontmatter": {},
      "regularPath": "/f42/t8.html",
      "relativePath": "f42/t8.md",
      "key": "v-4318750f",
      "path": "/f42/t8.html",
      "headers": [
        {
          "level": 2,
          "title": "三方工具    Microsoft Spy++  的使用介绍",
          "slug": "三方工具-microsoft-spy-的使用介绍"
        },
        {
          "level": 2,
          "title": "三方工具   PE Explorer   工具使用介绍",
          "slug": "三方工具-pe-explorer-工具使用介绍"
        },
        {
          "level": 2,
          "title": "官方工具  易助手插件打包器",
          "slug": "官方工具-易助手插件打包器"
        }
      ]
    },
    {
      "title": "注意事项",
      "frontmatter": {},
      "regularPath": "/f42/t9.html",
      "relativePath": "f42/t9.md",
      "key": "v-265f2b8d",
      "path": "/f42/t9.html",
      "headers": [
        {
          "level": 2,
          "title": "开发易语言助手需要注意哪些",
          "slug": "开发易语言助手需要注意哪些"
        }
      ]
    },
    {
      "title": "窗口相关",
      "frontmatter": {},
      "regularPath": "/f42/t6.html",
      "relativePath": "f42/t6.md",
      "key": "v-7c8b0813",
      "path": "/f42/t6.html",
      "headers": [
        {
          "level": 2,
          "title": "创建自定义窗口",
          "slug": "创建自定义窗口"
        },
        {
          "level": 2,
          "title": "获取窗口与控件的窗口改变大小",
          "slug": "获取窗口与控件的窗口改变大小"
        },
        {
          "level": 2,
          "title": "获取易语言IDE对话框窗口ID与菜单ID",
          "slug": "获取易语言ide对话框窗口id与菜单id"
        },
        {
          "level": 2,
          "title": "屏蔽信息框",
          "slug": "屏蔽信息框"
        },
        {
          "level": 2,
          "title": "添加自定义菜单",
          "slug": "添加自定义菜单"
        },
        {
          "level": 2,
          "title": "状态夹添加子夹与自定义窗口",
          "slug": "状态夹添加子夹与自定义窗口"
        },
        {
          "level": 2,
          "title": "代码视图加入自定义窗口",
          "slug": "代码视图加入自定义窗口"
        },
        {
          "level": 2,
          "title": "隐藏显示窗口",
          "slug": "隐藏显示窗口"
        },
        {
          "level": 2,
          "title": "拦截键盘消息统计键入信息",
          "slug": "拦截键盘消息统计键入信息"
        },
        {
          "level": 2,
          "title": "添加或隐藏自定义组件",
          "slug": "添加或隐藏自定义组件"
        }
      ]
    },
    {
      "title": "插件配置",
      "frontmatter": {},
      "regularPath": "/f42/t7.html",
      "relativePath": "f42/t7.md",
      "key": "v-5fd1be91",
      "path": "/f42/t7.html",
      "headers": [
        {
          "level": 2,
          "title": "易语言助手 - 插件页面",
          "slug": "易语言助手-插件页面"
        }
      ]
    },
    {
      "title": "接口文档",
      "frontmatter": {},
      "regularPath": "/f42/t5.html",
      "relativePath": "f42/t5.md",
      "key": "v-cd775cd6",
      "path": "/f42/t5.html",
      "headers": [
        {
          "level": 2,
          "title": "ET. 默认常用插件接口",
          "slug": "et-默认常用插件接口"
        },
        {
          "level": 2,
          "title": "常用API函数HOOK接口调用",
          "slug": "常用api函数hook接口调用"
        },
        {
          "level": 2,
          "title": "易语言IDE动作监听接口调用",
          "slug": "易语言ide动作监听接口调用"
        },
        {
          "level": 2,
          "title": "HOOK系统接口",
          "slug": "hook系统接口"
        },
        {
          "level": 2,
          "title": "常用接口",
          "slug": "常用接口"
        }
      ]
    }
  ],
  "themeConfig": {
    "nav": [
      {
        "text": "官网",
        "link": "http://e.125.la"
      },
      {
        "text": "社区",
        "link": "https://bbs.125.la"
      }
    ],
    "sidebar": [
      {
        "title": "指南",
        "collapsable": false,
        "sidebarDepth": 2,
        "children": [
          "/f41/t1.md",
          "/f41/t3.md"
        ]
      },
      {
        "title": "插件开发",
        "collapsable": false,
        "sidebarDepth": 2,
        "children": [
          "/f42/t4.md",
          "/f42/t5.md",
          "/f42/t6.md",
          "/f42/t7.md",
          "/f42/t8.md",
          "/f42/t9.md"
        ]
      }
    ]
  }
}